import { render } from "./staticimageedit.vue?vue&type=template&id=71d726bb"
import script from "./staticimageedit.vue?vue&type=script&lang=js"
export * from "./staticimageedit.vue?vue&type=script&lang=js"

import "./staticimageedit.vue?vue&type=style&index=0&id=71d726bb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__